import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import { useSelector } from "react-redux";
import InfoPopupHover from "../components/InfoPopupHover";
import { views } from "../utils";

export default function MarketingActionsFilter(props) {
  const { changeClientFilter } = props;
  const view = useSelector((state) => state.system.view);
  const loading = useSelector((state) => state.system.loading);

  const allActions = useSelector((state) => state.filter.allActions);

  const marketingActions = useSelector(
    (state) => state.filter.marketingActions
  );
  const hotelMarketingActions = useSelector(
    (state) => state.filter.hotelMarketingActions
  );
  const selectedMarketingActions = useSelector(
    (state) => state.search.selectedMarketingActions
  );

  //console.log(allActions);
  return (
    <>
      {allActions.length > 0 && (
        <div className="boardtypefilter">
          <span className="boardtypefilter1 filterheader">
            Marketingaktionen
          </span>
          {allActions.map((itm, kidx) => {
            let disabled = true;
            if (
              (view === views.offerview
                ? marketingActions
                : hotelMarketingActions
              )
                .map((e) => e.label)
                .includes(itm.label)
            ) {
              disabled = false;
            }
            if (selectedMarketingActions.includes(itm.label)) {
              disabled = false;
            }
            return (
              <React.Fragment key={kidx}>
                <div className="filterrow" key={itm.label}>
                  {itm.touroperator !== "agency" && (
                    <div className="filter1">
                      <input
                        className="boardtypefilter4"
                        disabled={disabled}
                        checked={selectedMarketingActions.includes(itm.label)}
                        onChange={() => {
                          let changed = [...selectedMarketingActions];
                          if (changed.includes(itm.label)) {
                            changed = changed.filter((e) => e !== itm.label);
                          } else {
                            changed.push(itm.label);
                          }
                          changeClientFilter(
                            "selectedMarketingActions",
                            changed
                          );
                        }}
                        type="checkbox"
                      />
                    </div>
                  )}
                  {itm.touroperator === "agency" && (
                    <div className="filter1"></div>
                  )}
                  <div className="filter2">
                    <div
                      className="filtertext"
                      dangerouslySetInnerHTML={{
                        __html:
                          "" +
                          itm.label +
                          " (" +
                          ((view === views.offerview
                            ? marketingActions
                            : hotelMarketingActions
                          )
                            .map((e) => e.label)
                            .includes(itm.label)
                            ? (view === views.offerview
                                ? marketingActions
                                : hotelMarketingActions
                              ).find((e) => e.label === itm.label).count
                            : "0") +
                          ")",
                      }}
                    ></div>

                    <InfoPopupHover
                      trigger={
                        <span>
                          <FaInfoCircle className="filterinfo" />
                        </span>
                      }
                      content={itm.mouseover}
                      position={"right center"}
                    ></InfoPopupHover>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </>
  );
}
